import Link from 'next/link';
import { useRouter } from 'next/router';

import { Anchor, Button, Text } from '@zillow/constellation-10';
import { IconCloseOutline } from '@zillow/constellation-icons';

import QueryConstants from '../../constants/QueryConstants';
import { ROUTES } from '../../constants/urls';

export const NoSearchResults = ({
  showArchived,
  onRemoveSearchTextClick,
}: {
  showArchived: boolean;
  onRemoveSearchTextClick: (value: string) => void;
}) => {
  const router = useRouter();

  return (
    <Text
      css={{
        textAlign: 'center',
        marginBottom: '800',
        padding: { sm: '0 400', lg: '0' },
      }}
    >
      No properties found for the following filters.
      {!showArchived && (
        <>
          {' '}
          Would you like to{' '}
          <Anchor asChild>
            <Link
              href={{ pathname: ROUTES.PROPERTIES, query: { ...router.query, [QueryConstants.POSTING_PATH]: 'true' } }}
            >
              post a listing
            </Link>
          </Anchor>
          ?
        </>
      )}
      <br />
      <Button
        tone="brand"
        emphasis="outlined"
        size="sm"
        icon={<IconCloseOutline />}
        iconPosition="end"
        onClick={() => onRemoveSearchTextClick('')}
        css={{ marginTop: '200' }}
      >
        Remove search
      </Button>
    </Text>
  );
};
